import { URL_HELPER } from "../../App";
import { IAPIComponent } from "../pages/AssetsPage";
import { CartItem, SetCart } from "./CartHelper";
import JSZip from "jszip";

const sizeMap: { [id: string]: string } = {
  "2000x2000": "Medium",
  raw: "Original",
};

interface CheckoutModalProps {
  api: IAPIComponent["api"];
  cart: Array<CartItem>;
  setCart: SetCart;
}

interface CheckoutItems {
  id: number;
  name: string;
  renditions: RenditionItem[];
  downloadUrl: string;
  extension: string;
}

class RenditionItem {
  url: string;
  size: string;
  contentLength: number;
  name: string;
  extension: string;

  constructor(
    assetId: number,
    rendition: { name: string; contentLength: number; extension: string }
  ) {
    this.size = rendition.name;
    this.url =
      rendition.name === "raw"
        ? `${URL_HELPER.getDownloadUrl()}/${assetId}`
        : `${URL_HELPER.getApiUrl()}/d/f/${assetId}/${rendition.name}`;
    this.contentLength = rendition.contentLength;
    this.name = sizeMap[rendition.name] || rendition.name;
    this.extension = rendition.extension;
  }
}

function downloadCheckoutItems(checkoutItems: CheckoutItems[]) {
  const zip = new JSZip();
  const promiseArray: Promise<any>[] = [];
  checkoutItems.forEach(async (checkoutItem) => {
    promiseArray.push(
      fetch(checkoutItem.downloadUrl as string)
        .then((response) => response.blob())
        .then((blob) => {
          zip.file(
            `${checkoutItem.name.replace(
              /\.\w+/,
              "." + checkoutItem.extension
            )}`,
            blob
          );
        })
    );
  });
  Promise.all(promiseArray).then(() => {
    zip.generateAsync({ type: "blob" }).then((content) => {
      const url = window.URL.createObjectURL(content);
      const a = document.createElement("a");
      a.href = url;
      a.download = `MediaCenter${
        new Date()
          .toISOString()
          .replace(/([A-z]|:)/g, "-")
          .split(".")[0]
      }.zip`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  });
}

export { RenditionItem, downloadCheckoutItems, sizeMap };
export type { CheckoutModalProps, CheckoutItems };
